(function() {
    'use strict';

    var ID = 'cutoff-text',
        elements = [];

    // FIXME: remove section below once we only output logs in dev env
    var log = function() {
        // console.log.apply(null, Array.prototype.slice.call(arguments));
    };

    /*
     *      CutoffText Class
     */
    var CutoffText = function($cutoffText) {
        this.$html = $cutoffText.addClass('initialized');
        return this.init();
    };

    CutoffText.prototype = {
        $html: {},
        $originalHtml: {},
        htmlElement: {},
        wantedHeight: '',
        wantedLines: 1,
        content: '',
        plainText: '',
        cuttedText: '',
        currentCharLen: 0,
        maxCharLen: 0,
        $mandatoryText: {},
        mandatoryText: '',
        mayBeBold: false,
        $link: {},
        isFullyShown: true,
        isTitleShown: true,
        isExpandable: false,

        init: function() {
            log(ID + ' :: init');
            this.$originalHtml = this.$html.html();
            this.htmlElement = this.$html[0];
            this.$mandatoryText = this.$html.find('.mandatory-text').detach();
            this.content = $.trim(this.htmlElement.innerText || this.htmlElement.textContent);
            this.plainText = this.content;
            this.maxCharLen = this.content.length;
            this.mandatoryText = this.$html.attr('data-mandatory-text') || '';
            this.mayBeBold = this.$html.hasClass('cutoff-bold');
            this.isTitleShown = this.$html.attr('data-show-title') !== 'false';
            this.isExpandable = this.$html.attr('data-expandable') === 'true';
            this.wantedHeight = 0;
            this.wantedLines = this.$html.attr('data-lines') || 1;
            this.$link = this.isExpandable ? $('<a>').text(' more') : null;

            if (this.wantedLines > 3) {
                this.content = $.trim(this.htmlElement.innerHTML);
            }

            // TODO: this could be loaded by imagesLoaded or something like that if needed
            this.onLoaded();

            return this;
        },

        initEventHandlers: function() {
            // EventHandler.bind( 'window::resize-complete', this.startCutoffAdjust.bind( this ) );
            this.$html.on('recalculate', this.startCutoffAdjust.bind(this));
            if (this.isExpandable) this.$link.on('click', this.onExpand.bind(this));
        },

        onLoaded: function() {
            this.initEventHandlers();

            this.$html.removeClass(ID);
            var height = this.$html.plainCSS('height');
            this.$html.addClass(ID);

            this.wantedHeight = height === 'auto' || this.wantedLines > 1 ? this.wantedLines + 'em' : height;

            if (!this.$html.prop('title') && this.isTitleShown) {
                this.$html.prop('title', this.plainText);
            }

            this.startCutoffAdjust();
        },

        startCutoffAdjust: function(e) {
            if (!this.$html.is(':visible')) return;

            this.currentCharLen = this.maxCharLen;
            this.isFullyShown = true;

            this.$html.css({
                height: this.wantedHeight,
                lineHeight: '1em',
                width: '100%'
            });

            if (this.mayBeBold) {
                this.$html.css('fontWeight', 700);
            }

            if (!/\s/g.test(this.content)) {
                this.$html.css('wordBreak', 'break-all');
            }

            var minCharLen = 0,
                maxCharLen = this.maxCharLen,
                steps = 0,
                newCharLen,
                newHeight,
                testText;

            // calculate wantedHeight
            this.$html.text('-');
            if (this.$mandatoryText.length) this.$html.append(this.$mandatoryText);
            var wantedHeight = this.htmlElement.scrollHeight + 5;
            if (this.$mandatoryText.length) this.$mandatoryText.detach();
            this.$html.html(this.$originalHtml).css('overflow', 'visible');

            if (this.htmlElement.scrollHeight > wantedHeight) {
                var textEnding = '...' + this.mandatoryText;
                if (this.isExpandable) {
                    textEnding += ' more';
                }

                // find the sweet spot with trial and error
                while (minCharLen <= maxCharLen) {
                    steps++;
                    newCharLen = (minCharLen + maxCharLen) / 2 | 0;
                    testText = this.content.substring(0, newCharLen);

                    // Fix issue with IE where overwriting .html() destroys the $mandatoryText
                    if (this.$mandatoryText.length) this.$mandatoryText.detach();

                    if (this.wantedLines > 1) {
                        this.$html.html(testText.replace(/[\n]/g, '<br/>') + textEnding);
                    } else {
                        this.$html.text(testText + textEnding);
                    }

                    if (this.$mandatoryText.length) {
                        this.$html.append(this.$mandatoryText);
                    }

                    newHeight = this.htmlElement.scrollHeight;

                    if (newHeight < wantedHeight) {
                        minCharLen = newCharLen + 1;
                    } else if (newHeight > wantedHeight) {
                        maxCharLen = newCharLen - 1;
                    } else {
                        break;
                    }
                }

                // cut a few more character off, just to be sure
                newCharLen -= this.mayBeBold && newCharLen > 10 ? 4 : 2;
                this.cuttedText = $.trim(this.content.substring(0, newCharLen)) + '...' + this.mandatoryText;

                // FIXME: Issue with IE where overwriting .html() destroys the $mandatoryText
                if (this.$mandatoryText.length) this.$mandatoryText.detach();

                if (this.wantedLines > 1) {
                    this.cuttedText = this.cuttedText.replace(/[\n]/g, '<br/>').replace(/<\/?[^>]+$/, '');
                    this.$html.html(this.cuttedText);
                } else {
                    this.$html.text(this.cuttedText);
                }

                if (this.$mandatoryText.length) {
                    this.$html.append(this.$mandatoryText);
                }

                if (this.isExpandable) this.$html.append(this.$link);

                this.currentCharLen = newCharLen;
                this.isFullyShown = false;
            }

            if (this.isFullyShown) {
                this.$html.parent('.fill-up').addClass('fully-shown');
            }

            this.$html.css({
                height: '',
                lineHeight: '',
                fontWeight: '',
                overflow: 'visible',
                width: '',
                wordBreak: ''
            });
        },

        onExpand: function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (this.isExpandable) {
                this.$link
                    .text(' ' + (this.isFullyShown ? 'more' : 'less'))
                    .toggleClass('right', !this.isFullyShown)
                    .detach();
            }

            if (!this.isFullyShown) {
                this.$html.html(this.$originalHtml);
            } else if (this.wantedLines > 1) {
                this.$html.html(this.cuttedText);
            } else {
                this.$html.text(this.cuttedText);
            }

            if (this.isExpandable) this.$html.append(this.$link);
            this.isFullyShown = !this.isFullyShown;
        }
    };

    /*
     *      Overall creator and eventhandler
     */
    var init = function() {
        log(ID + ' :: loaded');
        findCutoffTexts();
        initEventHandlers();
    },

    findCutoffTexts = function($parent) {
        var selector = '.' + ID + ':not( .initialized )',
            $domItems = $parent == null ? $(selector) : $parent.find(selector),
            len = $domItems.length;

        while (len--) {
            elements.push(new CutoffText($domItems.eq(len)));
        }
    },

    initEventHandlers = function() {
        EventHandler.bind( 'refresh', findCutoffTexts );
    };

    $(init);
})();
